import {
  sortDestinationIdFormat,
  sortingToteIdFormat,
  stationProcessingSessionIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";
import { StationProcessingSessionToteBindingViewSchema } from "./station-processing-session";

export const bindSortingTote = {
  name: "bindSortingTote" as const,
  input: z.object({
    sessionId: stationProcessingSessionIdFormat.schema,
    sortingToteId: sortingToteIdFormat.schema,
    sortDestinationId: sortDestinationIdFormat.schema,
  }),
  output: z.object({
    bindings: z.array(StationProcessingSessionToteBindingViewSchema),
  }),
};
